var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLympo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.5749L39.6422 31.1049H18.0011L0 0Z",
    fill: "url(#paint0_linear_8206_2744)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6659 10.5215H42.091L24.0898 41.6264H45.6647L63.6659 10.5215Z",
    fill: "url(#paint1_linear_8206_2744)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.867 25.4796H86.6309V0H80.3438V31.1049H99.867V25.4796Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.861 10.457C143.148 10.457 140.964 11.4497 139.508 13.4352C138.184 11.5159 136.133 10.457 133.551 10.457C131.301 10.457 129.514 11.2512 128.323 12.8395V11.0527H122.301V31.1054H128.323V21.443C128.323 17.8031 129.713 15.6853 132.096 15.6853C133.882 15.6853 134.875 16.9427 134.875 19.0605V31.1054H140.898V21.443C140.898 17.8031 142.287 15.6853 144.67 15.6853C146.457 15.6853 147.449 16.9427 147.449 19.0605V31.1054H153.472V18.4649C153.472 13.5014 150.56 10.457 145.861 10.457Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.097 10.457C165.781 10.457 163.928 11.185 162.604 12.641V11.0527H156.582V41.6281H162.604V29.3847C163.928 30.7745 165.781 31.5025 168.097 31.5025C173.524 31.5025 177.297 27.1345 177.297 20.9136C177.23 14.8249 173.392 10.457 168.097 10.457ZM171.274 20.9798C171.274 24.0903 169.487 26.208 166.906 26.208C164.325 26.208 162.538 24.0241 162.538 20.9798C162.538 17.9355 164.325 15.7515 166.906 15.7515C169.487 15.7515 171.274 17.8693 171.274 20.9798Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.609 10.457C183.653 10.457 179.152 15.0235 179.152 21.0459C179.152 27.0022 183.586 31.5025 189.543 31.5025C195.499 31.5025 199.999 26.936 199.999 20.9136C199.999 14.9573 195.565 10.457 189.609 10.457ZM193.977 21.0459C193.977 24.1564 192.256 26.2742 189.675 26.2742C187.028 26.2742 185.241 24.1564 185.241 20.9798C185.241 17.8693 186.962 15.7515 189.543 15.7515C192.124 15.7515 193.977 17.9354 193.977 21.0459Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.728 19.9208L104.433 10.7217H97.4844L106.286 26.0094L97.5506 41.628H103.705L120.78 11.0526H114.691L109.728 19.9208Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8206_2744",
    x1: -2.68468,
    y1: -8.31289,
    x2: 33.643,
    y2: 30.2853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02A53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8206_2744",
    x1: 49.1034,
    y1: 20.3716,
    x2: 20.7224,
    y2: 51.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02A53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLympo);
export default __webpack_public_path__ + "static/media/logo-lympo.8000adb19f456e18c608de64a2f45644.svg";
export { ForwardRef as ReactComponent };